export default __webpack_public_path__ + "static/media/brand_img04.22fd6b80.png";